import { __extends } from "tslib";
import { AppMessageHandler } from './app-message-handler';
import { AuthenticationWindowMessageHandler } from './auth-window-message-handler';
import { BaseMessageProcessor } from './base-message-processor';
/**
 * MessageProcessor for processing the message requests related to authentication Frame context which involves :
 * Routing message requests to proper handler
 * Posting response back to the app
 */
var AuthFrameMessageProcessor = /** @class */ (function (_super) {
    __extends(AuthFrameMessageProcessor, _super);
    /**
     * Registers different available handlers
     */
    function AuthFrameMessageProcessor(appSdkHost, authService, telemetryService) {
        var _this = _super.call(this, appSdkHost) || this;
        _this.appSdkHost = appSdkHost;
        _this.authService = authService;
        _this.telemetryService = telemetryService;
        _this.messageHandlers.push(new AuthenticationWindowMessageHandler(appSdkHost, authService, telemetryService));
        // In authentication FrameContext, App message handler doesnot need any hubservices
        _this.messageHandlers.push(new AppMessageHandler(appSdkHost, {}, telemetryService));
        _this.messageHandlers.forEach(function (handler) { return handler.initHandlers(); });
        return _this;
    }
    return AuthFrameMessageProcessor;
}(BaseMessageProcessor));
export { AuthFrameMessageProcessor };
//# sourceMappingURL=message-processor-auth.js.map